var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletWalletTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet transfer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8565 10.8036C11.8565 9.34758 13.0325 8.17156 14.4805 8.17156H17.6869C17.8201 8.17156 17.9285 8.06293 17.9203 7.93001C17.7798 5.65815 15.8872 3.85156 13.5765 3.85156H7.07252C4.68052 3.85156 2.72852 5.80356 2.72852 8.20356V10.8561C2.72852 11.07 3.00748 11.1942 3.20461 11.1114C3.24564 11.0941 3.28708 11.0794 3.32852 11.0676C3.84592 10.8458 4.47369 10.8871 4.96852 11.1476C5.12948 11.2165 5.3013 11.3364 5.44852 11.4836L5.47252 11.5076L5.75413 11.7804C5.86921 11.8919 6.05952 11.8609 6.15526 11.7324C6.52026 11.2425 7.09979 10.9236 7.76052 10.9236C8.86451 10.9236 9.76051 11.8196 9.76051 12.9236V13.9557C9.76051 14.0604 9.82907 14.1517 9.92555 14.1922C10.1683 14.2944 10.3964 14.4489 10.5925 14.6516C11.3525 15.4436 11.3365 16.7076 10.5365 17.4756L10.475 17.535C10.3199 17.685 10.4261 17.9476 10.6419 17.9476H13.5765C15.9946 17.9476 17.8053 15.9929 17.9225 13.6675C17.9291 13.5352 17.8211 13.4276 17.6885 13.4276H14.4805C13.0325 13.4276 11.8565 12.2516 11.8565 10.8036Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1606 10.7531C15.1606 11.0811 14.8886 11.3531 14.5606 11.3531H14.5526C14.2246 11.3531 13.9526 11.0811 13.9526 10.7531C13.9526 10.4171 14.2246 10.1531 14.5526 10.1531C14.8886 10.1531 15.1606 10.4171 15.1606 10.7531ZM13.0566 10.8011C13.0566 11.5851 13.6966 12.2251 14.4806 12.2251H17.6886C17.8212 12.2251 17.9286 12.1177 17.9286 11.9851V9.60914C17.9286 9.47658 17.8212 9.36914 17.6886 9.36914H14.4806C13.6966 9.36914 13.0566 10.0091 13.0566 10.8011Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73137 15.6011L8.36097 15.9579V12.9203C8.36097 12.5891 8.09217 12.3203 7.76098 12.3203C7.42978 12.3203 7.16098 12.5891 7.16098 12.9203V15.9571L6.79138 15.6011C6.55298 15.3715 6.17378 15.3787 5.94338 15.6171C5.71378 15.8555 5.72018 16.2355 5.95858 16.4651L7.33618 17.7923L7.33858 17.7947C7.45442 17.8977 7.59178 17.9633 7.74818 17.9667C7.89189 17.9667 8.07233 17.9045 8.17857 17.8011L9.56417 16.4651C9.80257 16.2355 9.80977 15.8547 9.58017 15.6171C9.34897 15.3787 8.96977 15.3715 8.73137 15.6011Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86106 13.8259L4.48426 12.4995C4.48255 12.496 4.47803 12.4928 4.47546 12.4899C4.25223 12.276 3.86648 12.2724 3.64266 12.4899L2.25546 13.8259C2.01706 14.0555 2.01066 14.4355 2.24026 14.6747C2.35786 14.7963 2.51466 14.8579 2.67226 14.8579C2.82186 14.8579 2.97226 14.8027 3.08826 14.6899L3.45946 14.3323V17.3707C3.45946 17.7019 3.72826 17.9707 4.05946 17.9707C4.39066 17.9707 4.65946 17.7019 4.65946 17.3707V14.3347L5.02826 14.6899C5.26746 14.9203 5.64666 14.9131 5.87706 14.6747C6.10666 14.4363 6.09946 14.0555 5.86106 13.8259Z",
    fill: "#E5B910"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletWalletTransfer);
export default __webpack_public_path__ + "static/media/wallet-wallet-transfer.b357c1b9c79885f973eb6801ee8a8b41.svg";
export { ForwardRef as ReactComponent };